import React from "react";

type Props = {
    className?  : string
    title?      : string
}

export default function PopoverMenuHeader(props:Props) {

    return (
        <div className={Classes("ui5-header s11 no-accent", props.className)}>
            <div className="left">
                <div className="name">{props.title}</div>
            </div>
        </div>
    )

}